
export function findItem (arr, value, key) {
  // TODO: 增加异常处理，判断参数类型
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] === value) {
      return arr[i]
    }
  }
  return {}
}
